import { useQuery } from "@tanstack/react-query";

import { mutateData } from "@/core/api/api-methods";
import type { ListRequest, Paged } from "@/core/api/pagination";
import { QUERY_KEYS } from "@/core/api/query-keys";
import { feeEngineEndpoints } from "@/features/fee-engine/api/endpoints";
import type {
  FeeRuleDto,
  FeeRuleFilter,
} from "@/features/fee-engine/api/dto";

/**
 * Liste paginée des règles de frais (`POST /FeeRules/all`, guide §4.2).
 * Lecture authentifiée : `mutateData` en queryFn, la requête reste une
 * query TanStack (cache, invalidation).
 */
export const useFeeRules = (
  params: ListRequest<FeeRuleFilter> = {},
  enabled = true
) =>
  useQuery({
    queryKey: QUERY_KEYS.FEE_RULES_LIST(params),
    queryFn: () =>
      mutateData({
        url: feeEngineEndpoints.feeRules.all,
        reqBody: params as unknown as Record<string, unknown>,
        method: "POST",
      }) as Promise<Paged<FeeRuleDto>>,
    enabled,
  });
